import React, { useState } from 'react';
import styles from './style.module.css';
import { useEffect } from 'react';
import { parseCurrency } from '../../utils/currency';
import { BiSolidUpArrow, BiSolidDownArrow } from 'react-icons/bi';
import statusSettings from '../../utils/statusArray';
import moment from 'moment-timezone';

const VerticalTabs = ({ data, type, maxSize }) => {  

  const [currentIndex, setCurrentIndex] = useState(() => {
    if (type !== 'contracts' && data && data.length > 0) {
      const index = data.findIndex(item => item.installment_number === Math.min(...data.map(d => d.installment_number)));
      return index >= 0 ? index : 0;
    }
    return 0;
  });
 
  const goUp = () => {
    if (data && data.length > 1) {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + data.length) % data.length);
    }
  };

  const goDown = () => {
    if (data && data.length > 1) {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
    }
  };

  const calculateDelayDays = (inputDate) => {
    if (!inputDate) return "-";

    // Compara somente a data no fuso de Sao Paulo para evitar
    // diferenca de 1 dia causada por horario/timezone.
    const providedDate = moment
      .utc(inputDate)
      .tz("America/Sao_Paulo")
      .startOf("day");
    const currentDate = moment
      .tz("America/Sao_Paulo")
      .startOf("day");

    const dayDifference = currentDate.diff(providedDate, "days");

    return dayDifference > 0 ? dayDifference : "-";
  }

  const getStatusLabel = (statusValue) => {
    const found = statusSettings.find(status => status.value === statusValue);
    return found ? found.label : "-";
  }

  useEffect(() => {
  }, [data]);

  if (type === 'contracts') {
    const value =
    data[currentIndex]?.originalAmount ||
    data[currentIndex]?.discountAmount ||
    data[currentIndex]?.amount || 0;
    return (
      <div className={styles.wrapper}>
        {data && data.length > 1 && (
          <div className={`${styles.item} ${styles.itemArrow}`} onClick={goUp}>
            <i><BiSolidUpArrow /></i>
            <div>{data[currentIndex - 1 < 0 ? data.length - 1 : currentIndex - 1]?.contract}</div>
          </div>
        )}
        <div className={`${styles.item} ${styles.main}`}>
          <div className={styles.contentItem}>
            <span>Número</span> <b>{data[currentIndex]?.contract ? data[currentIndex]?.contract : "-"}</b>          
          </div>
  
          <div className={styles.contentItem}>
            <span>Parcela</span><b>{parseCurrency(value)}</b>          
          </div>
  
          <div className={styles.contentItem}>
            <span>Vencimento</span><b>{data[currentIndex]?.validDueDate ? moment.utc(data[currentIndex]?.validDueDate).tz("America/Sao_Paulo").format("DD-MM-YYYY") : "-"}</b>         
          </div>
  
          <div className={styles.contentItem}>
            <span>Atraso</span><b>{calculateDelayDays(data[currentIndex]?.validDueDate)}</b>        
          </div>
  
          <div className={styles.contentItem}>
            <span>Corrigido</span>
            <b>{parseCurrency(data[currentIndex]?.amount ?? data[currentIndex]?.originalAmount)}</b>
          </div>
        </div>
        {data && data.length > 1 && (
          <div className={`${styles.item} ${styles.itemArrow}`} onClick={goDown}>
            <i><BiSolidDownArrow /></i>
            <div>{data[(currentIndex + 1) % data.length]?.contract}</div>
          </div>
        )}
      </div>
    );
  }

  if (type === 'conditions') {
    return (
      <div className={styles.wrapper}>
        {data && data.length > 0 && (
          <div>
            <div className={`${styles.itemCondition}`}>
              <div className={styles.itemContainer}>
                <h4> Produto Negociado: </h4>
                <span> {data[0].reason} </span>
              </div>

              <div className={styles.itemContainer}>
                <h4> Pagamento à vista(desconto): </h4>
                <span> {data[0]?.discount && `${data[0].discount}% de desconto`} </span>
              </div>

              <div className={styles.itemContainer}>
                <h5> {data[0].discountAmount && parseCurrency(data[0].discountAmount)} </h5>
              </div>
            </div>

            <div className={`${styles.item}`}>
              <div className={styles.itemContainer}>
                <h4> Produto Negociado: </h4>
                <span> {data[0]?.reason} </span>
              </div>

              <div className={styles.itemContainer}>
                <h4> Parcelado: </h4>
                <span> {data[0]?.installments && `Entrada de ${parseCurrency(data[0]?.entrance)}`} </span>
              </div>

              <div className={styles.itemContainer}>
                <h5> {`${data[0]?.installments}x ${parseCurrency(data[0]?.installmentAmount)}`} </h5>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  if (data && data.length > 0) {
    return (
      <div className={styles.wrapper}>
        {data && data.length > 1 && (
          <div className={`${styles.item} ${styles.itemArrow}`} onClick={goUp}>
            <i><BiSolidUpArrow /></i>
            <div></div>
          </div>
        )}
        <div className={`${styles.item} ${styles.main}`}>
          <div className={styles.contentItem}>
            <span>Parcela</span>
            <b>
              {data[currentIndex]?.installment_number ? `${data[currentIndex]?.installment_number}/${maxSize}` : "1/1"}
            </b>          
          </div>
  
          <div className={styles.contentItem}>
            <span>Valor</span><b>{data[currentIndex]?.amount ? parseCurrency(data[currentIndex]?.amount) : "-"}</b>      
          </div>
  
          <div className={styles.contentItem}>
            <span>Vencimento</span>
            <b>
              {data[currentIndex]?.pix_expiration_date
                ? moment.utc(data[currentIndex].pix_expiration_date)
                  .tz("America/Sao_Paulo")
                  .format("DD-MM-YYYY")
                : "-"
              }
            </b>
          </div>
  
          <div className={styles.contentItem}>
            <span>Status</span>
            <b>{getStatusLabel(data[currentIndex]?.status)}</b>
          </div>

        </div>
        {data && data.length > 1 && (
          <div className={`${styles.item} ${styles.itemArrow}`} onClick={goDown}>
            <i><BiSolidDownArrow /></i>
            <div></div>
          </div>
        )}
      </div>
    );
  }

  return <></>
}

export default VerticalTabs;
